export const ContabilLancamento = {
  // Letra A:
  AVISO_LANCAMENTOS_DESBALANCEADOS: 'Lançamentos pendentes de ajuste',
  AVISO_LANCAMENTO_DESBALANCEADO_MENSAGEM:
    'Existe 1 lançamento manual com débito diferente de crédito. Confira-o em Lançamentos contábeis, filtro "Somente desbalanceados", antes do fechamento do período.',
  AVISO_LANCAMENTOS_DESBALANCEADOS_MENSAGEM:
    'Existem {quantidade} lançamentos manuais com débito diferente de crédito. Confira-os em Lançamentos contábeis, filtro "Somente desbalanceados", antes do fechamento do período.',
  // Letra B:
  BUSCAR_DOCUMENTO_ORIGEM: 'Buscar documento origem',
  // Letra C:
  CONFIRMAR_EXCLUIR_DOCUMENTO: 'Excluir lançamento contábil',
  CONFIRMAR_EXCLUIR_DOCUMENTO_MENSAGEM:
    'Deseja excluir este lançamento contábil?',
  CONFIRMAR_EXCLUIR_DOCUMENTO_ITEM:
    'Confirme a exclusão do lançamento vinculado',
  CONFIRMAR_EXCLUIR_DOCUMENTO_ITEM_MENSAGEM:
    'Deseja excluir este lançamento vinculado?',
  CONFIRMAR_DIFERENCA_DEBITO_CREDITO: 'Débito diferente de crédito',
  CONFIRMAR_DIFERENCA_DEBITO_CREDITO_MENSAGEM:
    'Os totais de débito ({debito}) e crédito ({credito}) não conferem. Deseja salvar mesmo assim? O período só poderá ser fechado depois do ajuste.',
  // Letra D:
  DESBALANCEADO: 'Desbalanceado',
  DIGITAR_CODIGO: 'Digitar código do documento',
  // Letra E:
  // Letra F:
  // Letra G:
  // Letra H:
  // Letra I:
  // Letra J:
  // Letra K:
  // Letra L:
  // Letra M:
  // Letra N:
  // Letra O:
  // Letra P:
  PAGE_DESCRIPTION:
    'Um lançamento é um reconhecimento de um ativo, passivo, receita ou despesa em um determinado tempo. Registre aqui os lançamentos ou utilize o filtro para encontrar um lançamento já registrado.',

  // Letra Q:
  // Letra R:
  // Letra S:
  SELECIONAR_DOCUMENTO_ORIGEM: 'Selecionar documento de origem',
  SOMENTE_DESBALANCEADOS: 'Somente desbalanceados',
  SELECIONAR_TIPO_CONTA: 'Selecionar tipo de documento origem',
  // Letra T:
  // Letra U:
  // Letra V:
  // Letra X:
  // Letra Y:
  // Letra Z:
};
